import React, { Component } from 'react'
import { withTranslation } from 'react-i18next';
import styled from 'styled-components'
import Moment from 'moment';
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { actions as employeeActions } from '../../../actions/employee'

const Container = styled.div`
  
  background-color: #FFFFFF;
  
  // Desktop version.
  @media (min-width: 768px) {
    display: table-row;
    box-shadow: inset 2px 0 0 0 #DB3766;

    .award-cell1 {
      display: table-cell;
      padding-top: 15px;
      padding-bottom: 15px;
      padding-left: 20px;
      vertical-align: top;
      white-space: nowrap;
      width: 200px;
    }  
  
    .award-cell2 {
      display: table-cell;
      padding-top: 19px;
      padding-bottom: 11px;
      padding-left: 25px;
      vertical-align: top;
      width: 110px;
    }  
  
    .award-cell3 {
      display: table-cell;
      padding-top: 19px;
      padding-bottom: 11px;
      padding-left: 25px;
      vertical-align: top;
      width: 110px;
    }  
  
    .award-cell4 {
      display: table-cell;
      padding-top: 15px;
      padding-bottom: 15px;
      padding-right: 20px;
      vertical-align: top;
    }    
  }  

  // Mobile version.
  @media (max-width: 768px) {
    box-shadow: inset 0 2px 0 0 #DB3766;
    padding: 11px 15px 10px 15px;
  } 

  > div {
    // Desktop version.
    @media (min-width: 768px) {
      display: inline-block;
    }  
  
    // Mobile version.
    @media (max-width: 768px) {
      display: block;
      margin-bottom: 8px;
    } 
  }

  div:nth-child(1) {
    margin-right: 35px;
    
    span:nth-child(1) {
      display: block;
      font-family: Lato-Light;
      font-size: 18px;
      color: #4D4D4D;
      line-height: 22px;
    }

    span:nth-child(2) {
      display: block;
      font-family: Lato-Regular;
      font-size: 12px;
      color: #666666;
      line-height: 16px;
      margin-top: 2px;
    }
  }

  div:nth-child(2), div:nth-child(3) {
    span:nth-child(1) {
      display: block;
      font-family: Lato-Regular;
      font-size: 12px;
      color: #666666;
      line-height: 16px;
    }

    span:nth-child(2) {
      display: block;
      font-family: Lato-Regular;
      font-size: 14px;
      color: #2B2B2B;
      line-height: 22px;
    }
  }
  
  button {
    height: 43px;
    width: 126px;

    // Desktop version.
    @media (min-width: 768px) {
      float: right;
    }  
  
    // Mobile version.
    @media (max-width: 768px) {
      width: 100%;
      margin-top: 5px;      
    } 
  }  

`

export class UnacceptedStockAward extends Component {

  buttonClickHandler = (callback) => {
    this.props.onClick(this.props.award, callback)
  }
  
  render() {
    const { t } = this.props;
    const { awarded_date, shares_awarded, next_vest_date} = this.props.award
    const locale = this.props.locale;

    const rsus = new Intl.NumberFormat(locale).format(shares_awarded);
    const vest_date = next_vest_date ? Moment(next_vest_date).format('ll') : ""
    return (
      <Container className="unaccepted-award">
          <div className="award-cell1">
            <span>{`${this.props.award.amazon_award_name} | ${this.props.award.amazon_award_id}`}</span>
            <span>{t('UnacceptedStockAwards.AwardedOnLabel', {awarded_date: Moment(awarded_date).format('ll')})}</span>
          </div>
          <div className="award-cell2">
            <span>{t('UnacceptedStockAwards.NextVestDate')}</span>
            <span>{vest_date}</span>
          </div>
          <div className="award-cell3">
            <span>{t('UnacceptedStockAwards.RSUSAwarded')}</span>
            <span>{rsus}</span>
          </div>
          <div className="award-cell4">
            <button aria-haspopup="true" className='primary-button review-button' onClick={this.buttonClickHandler} >{t('UnacceptedStockAwards.ReviewButton')}</button>
          </div>
      </Container>
    )
  }
}

const mapState = state => ({
   locale: state.employee.language 
})

const mapDispatchToProps = dispatch => ({
  actions: {
    employee: bindActionCreators(employeeActions, dispatch)
  }
})

export default connect(mapState,mapDispatchToProps)(withTranslation("translations")(UnacceptedStockAward));

